import { call, put, takeLatest } from "redux-saga/effects";
import services from "../../services";

import {
  GET_ALL_STATICS,
  GET_ALL_STATICS_SUCCESS,
  GET_ALL_STATICS_ERROR,
} from "../types/statics";

function* getAllStatics({payload}) {
  try {
    const { response, error } = yield call(services.statics.getAll, {
      page: 0,
      limit: 5000,
    });

    if (error) {
      yield put({
        type: GET_ALL_STATICS_ERROR,
        payload: error,
      });
    } else {
      yield put({
        type: GET_ALL_STATICS_SUCCESS,
        payload: response,
      });
      if (payload.callback) {
        yield call(payload.callback);
      }
    }
  } catch (error) {
    yield put({
      type: GET_ALL_STATICS_ERROR,
      payload: "Error encontrado al buscar estaticos",
    });
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<any>(GET_ALL_STATICS, getAllStatics);
}
